module.exports = __webpack_public_path__ + "img/ICONE-LOCALISATION.0421aab0.svg";